import React, { FunctionComponent, useState, useMemo, useCallback } from 'react'

// Custom
import MapContext from "./MapContext";

// Types
import { BoolSettings } from "@/@types/common";
import { MapContextProviderProps, HeatMapCQLType, StringSettings } from "@/@types/context/MapContext";

const MapContextProvider: FunctionComponent<MapContextProviderProps> = (props) => {

  const [forceRefreshCounter, setForceRefreshCounter] = useState(0);

  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const [heatMapCQL, setHeatMapCQL] = useState<HeatMapCQLType>({ date_from: "", date_to: "" });

  const { map, initOptions, mapId, children } = props;

  const setLayerVisibility = useCallback((id: string, isVisible: boolean) => {
    const key: string = "maplayers";
    let settings = null;

    const item = localStorage.getItem(key);
    if (item) {
      try {
        settings = JSON.parse(item);
      }
      catch (e) {
        // do nothing
      }
    }

    if (settings === null || Object.keys(settings).length === 0) {
      localStorage.setItem(key, JSON.stringify({ [id]: isVisible }));
    } else {
      settings[id] = isVisible;
      localStorage.setItem(key, JSON.stringify(settings));
    }

    setForceRefreshCounter(prev => prev + 1);
  }, []);

  const getLayerVisibility = useCallback(() => {
    const key: string = "maplayers";
    let settings = {} as BoolSettings;

    const item = localStorage.getItem(key);
    if (item) {
      try {
        settings = JSON.parse(item) as BoolSettings;
      }
      catch (e) {
        // do nothing
      }
    }

    return settings ?? {};
  }, []);

  const setLayerTime = (id: string, time: string) => {
    const key = 'layerstime';

    const item = localStorage.getItem(key);
    const settings = item ? JSON.parse(item) : null;
    if (settings === null || Object.keys(settings).length === 0) {
      localStorage.setItem(key, JSON.stringify({ [id]: time }));
    } else {
      settings[id] = time;
      localStorage.setItem(key, JSON.stringify(settings));
    }

    setForceRefreshCounter((prev) => prev + 1);
  };

  const getLayerTime = () => {
    const key = 'layerstime';
    const item = localStorage.getItem(key);
    const settings = item ? JSON.parse(item) : null;

    return settings ? (settings as StringSettings) : ({} as StringSettings);
  };

  const providerValue = useMemo(() => ({
    map,
    mapId,
    initOptions,
    setLayerVisibility,
    getLayerVisibility,
    setLayerTime,
    getLayerTime,
    forceRefreshCounter,
    sidebarCollapsed,
    setSidebarCollapsed,
    heatMapCQL,
    setHeatMapCQL
  }), [ map, initOptions, forceRefreshCounter, sidebarCollapsed, heatMapCQL]);

  return (
    <MapContext.Provider value={providerValue}>
      {children}
    </MapContext.Provider>
  )

}

export default MapContextProvider;